module.exports = __webpack_public_path__ + "static/media/MSIG Logo Horizontal.e53f3110.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/MSIG Logo Horizontal.png
// module id = 1240
// module chunks = 0